import Link from '@salesforce/retail-react-app/app/components/link';
import {Button} from '@salesforce/retail-react-app/app/components/shared/ui';

import {RAW_COMPONENTS as BASE_RAW_COMPONENTS} from '@amblique/base/app/constants/raw-components';
import {EmbeddedAssetBlock} from '@amblique/contentful/app/components/rich-text-content/embedded-asset-block';
import {EmbeddedEntryBlock} from '@amblique/contentful/app/components/rich-text-content/embedded-entry-block';

const RAW_COMPONENTS = {
  ...BASE_RAW_COMPONENTS,

  'a': [Link, {parse: false}],
  'a[button]': [Button, {as: Link, parse: false}],

  // Rich Text embedded content bridge components
  // These handle <div role="embedded-entry-block"> and <div role="embedded-asset-block">
  // generated by RichTextContent component
  'div[embedded-entry-block]': EmbeddedEntryBlock,
  'div[embedded-asset-block]': EmbeddedAssetBlock,
};

export {RAW_COMPONENTS};
